// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"layout_wrapper__FQZuc"};